export default __webpack_public_path__ + "static/media/guide.3c74f40f.png";